import { render, staticRenderFns } from "./10_CpfQuestion.vue?vue&type=template&id=578a8706&scoped=true&"
import script from "./10_CpfQuestion.vue?vue&type=script&lang=js&"
export * from "./10_CpfQuestion.vue?vue&type=script&lang=js&"
import style0 from "./10_CpfQuestion.vue?vue&type=style&index=0&id=578a8706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a8706",
  null
  
)

export default component.exports